export const getInsuranceClaimApi = (params, query) => {
    const queryString = new URLSearchParams(query).toString();
    return `lease/${params?.leaseSlug}/insurances${queryString ? `?${queryString}` : ""}`;
};

// Get Insurance and Claim Card details
export const getInsuranceClaimCardApi = (params, query) => {
    return `lease/${params?.leaseSlug}/insurances/config-details`;
};

export const deleteInsuranceApi = (params) => {
    return `lease/${params?.leaseSlug}/insurances`;
};

export const addInsuranceApi = (params) => {
    return `lease/${params?.leaseSlug}/insurances`;
};


export const updateInsuranceApi = (params) => {
    return `lease/${params?.leaseSlug}/insurances/${params?.slug}`;
};

// Update Insurance and Claim Card details
export const updateInsuranceClaimCardApi = (params) => {
    return `lease/${params?.leaseSlug}/insurances/config-details`;
};

export const insurancefileUploadApi = (slug) => {
    return `lease/insurance/${slug}/attachments`;
};

export const addClaimApi = (params) => {
    return `lease/${params?.leaseSlug}/insurances/${params?.insuranceSlug}/claims`;
};


export const updateClaimApi = (params) => {
    return `lease/${params?.leaseSlug}/insurances/${params?.insuranceSlug}/claims/${params?.slug}`;
};

export const deleteClaimApi = (params) => {
    return `lease/${params?.leaseSlug}/insurances/${params?.insuranceSlug}/claims`;
};
export const claimfileUploadApi = (slug) => {
    return `lease/insurance-claim/${slug}/attachments`;
};
export const variabilitiesListAPI = (lease_slug,insurance_slug) => {
    return `lease/${lease_slug}/insurances/${insurance_slug}/variabilities`;
};
export const variabilitiesUpdateAPI = (lease_slug,insurance_slug) => {
    return `lease/${lease_slug}/insurances/${insurance_slug}/variabilities`;
};

